import axios from 'axios';

export const chargePointService = {
    updateChargerPoint,
    addChargePoint,
    getChargePointById,
    deleteChargePoint,
    getDriverChargers,
    getPublicChargers,
    getChargers,
    getAllChargers,
    getUserChargerPreferences,
    updateUserChargerPreferences,
    getFavoriteChargers,
    addFavoriteCharger,
    removeFavoriteCharger,
    getSmartChargingInfo
};
export default chargePointService;

window.chargePointService = chargePointService;

async function addChargePoint(chargePoint) {
    return await axios.post('/chargepoints', chargePoint);
}

async function updateChargerPoint(chargerPoint) {
    return await axios.put('/chargePoints/update', chargerPoint);
}

async function getChargePointById(chargerPointId) {
    return await axios.get(`/chargePoints/GetCharger/${chargerPointId}`);
}

async function deleteChargePoint(chargerPointId) {
    return await axios.delete(`/chargePoints/delete/${chargerPointId}`);
}

async function getChargers() {
    return await axios.get(`/chargePoints`);
}

async function getAllChargers() {
    return await axios.get(`/chargePoints/ChargersForMobile`);
}
async function getDriverChargers() {
    return await axios.get(`/chargePoints/getDriverChargers`);
}

async function getPublicChargers() {
    return await axios.get(`/chargePoints/PublicChargers`);
}

async function getUserChargerPreferences(filterParams) {
    return await axios.get(`/chargepoints/UserPreferences`,{ params: filterParams });
}
async function getFavoriteChargers() {
    return await axios.get(`/chargepoints/getFavoriteChargers`);
}
async function addFavoriteCharger(id) {
    return await axios.post(`/chargepoints/AddFavoriteCharger/${id}`);
}
async function removeFavoriteCharger(id) {
    return await axios.delete(`/chargepoints/RemoveFavoriteCharger/${id}`);
} 

async function updateUserChargerPreferences(request) {
    return await axios.post('/chargepoints/UpdateUserPreferences', request);
}

async function getSmartChargingInfo(data) {
    return await axios.get(`/ocpp/smartChargingInfo/${data}`);
}